var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row row-single setting" }, [
      _vm._m(1),
      _vm._v(" "),
      _vm.$root.app.platform == "android"
        ? _c("div", { staticClass: "col col-20" }, [
            _c("div", { staticClass: "checkbox-wrap" }, [
              _c("input", {
                staticClass: "cbx hidden",
                attrs: { id: "insSwitch", name: "auth", type: "checkbox" },
                domProps: { checked: _vm.settings.numberSwitchIndividual == 1 },
                on: { change: _vm.insSwitch }
              }),
              _vm._v(" "),
              _c("label", { staticClass: "lbl", attrs: { for: "insSwitch" } })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-20 col-switch" }, [
            _c(
              "label",
              { staticClass: "switch", attrs: { for: "insSwitch" } },
              [
                _c("input", {
                  attrs: { id: "insSwitch", name: "auth", type: "checkbox" },
                  domProps: {
                    checked: _vm.settings.numberSwitchIndividual == 1
                  },
                  on: { change: _vm.insSwitch }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "slider round" })
              ]
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm._m(3),
    _vm._v(" "),
    _c("div", { staticClass: "row row-first setting" }, [
      _vm._m(4),
      _vm._v(" "),
      _vm.$root.app.platform == "android"
        ? _c("div", { staticClass: "col col-20" }, [
            _c("div", { staticClass: "checkbox-wrap" }, [
              _c("input", {
                staticClass: "cbx hidden",
                attrs: { id: "authSwitch", name: "auth", type: "checkbox" },
                domProps: { checked: _vm.settings.twoStepVerification == 1 },
                on: { change: _vm.authSwitch }
              }),
              _vm._v(" "),
              _c("label", { staticClass: "lbl", attrs: { for: "authSwitch" } })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-20 col-switch" }, [
            _c(
              "label",
              { staticClass: "switch", attrs: { for: "authSwitch" } },
              [
                _c("input", {
                  attrs: { id: "authSwitch", name: "auth", type: "checkbox" },
                  domProps: { checked: _vm.settings.twoStepVerification == 1 },
                  on: { change: _vm.authSwitch }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "slider round" })
              ]
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row setting row-last" }, [
      _vm.$root.app.platform == "android"
        ? _c("div", { staticClass: "col col-100" }, [
            _c("span", { staticClass: "row__title" }, [
              _vm._v("Verificatie methode")
            ]),
            _c("br"),
            _vm._v("\n                E-mail\n            ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-70" }, [
            _c("span", { staticClass: "row__title" }, [
              _vm._v("Verificatie methode")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-30 text-right" }, [
            _c("span", { staticClass: "row__subtitle" }, [_vm._v("E-mail")])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _vm._m(6),
    _vm._v(" "),
    _c("div", { staticClass: "row row-single setting" }, [
      _vm._m(7),
      _vm._v(" "),
      _vm.$root.app.platform == "android"
        ? _c("div", { staticClass: "col col-20" }, [
            _c("div", { staticClass: "checkbox-wrap" }, [
              _c("input", {
                staticClass: "cbx hidden",
                attrs: {
                  id: "newsletterSwitch",
                  name: "newsletter",
                  type: "checkbox"
                },
                domProps: { checked: _vm.settings.newsletter == 1 },
                on: { change: _vm.newsletterSwitch }
              }),
              _vm._v(" "),
              _c("label", {
                staticClass: "lbl",
                attrs: { for: "newsletterSwitch" }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-20 col-switch" }, [
            _c(
              "label",
              { staticClass: "switch", attrs: { for: "newsletterSwitch" } },
              [
                _c("input", {
                  attrs: {
                    id: "newsletterSwitch",
                    name: "newsletter",
                    type: "checkbox"
                  },
                  domProps: { checked: _vm.settings.newsletter == 1 },
                  on: { change: _vm.newsletterSwitch }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "slider round" })
              ]
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
    _vm._v(" "),
    _vm._m(8),
    _vm._v(" "),
    _c("div", { staticClass: "row setting row-first" }, [
      _vm.$root.app.platform == "android"
        ? _c("div", { staticClass: "col col-100" }, [
            _c("span", { staticClass: "row__title" }, [_vm._v("Versie")]),
            _c("br"),
            _vm._v(
              "\n                " +
                _vm._s(_vm.$root.app.version) +
                "\n            "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [_vm._v("Versie")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50 text-right" }, [
            _c("span", { staticClass: "row__subtitle" }, [
              _vm._v(_vm._s(_vm.$root.app.version))
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row setting row-last" },
      [
        _c("router-link", { attrs: { to: "/feedback" } }, [
          _c("div", { staticClass: "col col-100" }, [
            _c("div", { staticClass: "small" }, [
              _vm._v(_vm._s(_vm.$root.app.notes))
            ])
          ])
        ])
      ],
      1
    ),
    _vm._v(" "),
    _vm.$root.app.platform == "ios"
      ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Telefonie")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col col-80" }, [
      _c("span", { staticClass: "row__title" }, [
        _vm._v("Individueel nummer wisselen")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row setting row-last explanation" }, [
      _c("div", [
        _vm._v(
          '\n                Wanneer je "Individueel nummer wisselen" aan zet kunnen de op het account aangesloten smartphones zelf instellen met welk nummer ze uitgaand bellen.'
        ),
        _c("br"),
        _vm._v(
          " Dit werkt alleen als je meerdere nummers en smartphones in het account hebt.\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Beveiliging")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col col-80" }, [
      _c("span", { staticClass: "row__title" }, [
        _vm._v("Twee-staps verificatie")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row setting row-last explanation" }, [
      _c("div", [
        _vm._v(
          '\n                Wanneer je "Tweestaps verificatie" inschakelt wordt er tijdens het inloggen op de app een e-mail verstuurd welke bevestigd dient te worden. \n                Jouw account is op deze manier extra beveiligd.\n            '
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Communicatie")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col col-80" }, [
      _c("span", { staticClass: "row__title" }, [
        _vm._v("Nieuwsbrief ontvangen")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Over My Dubline")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47aa12d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47aa12d3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = null
// module chunks = 